import { Link } from 'react-router-dom';

const showcaseImages = [
  {
    src: "https://public.readdy.ai/ai/img_res/04c9af22243ba2bc5cacede10714b085.jpg",
    label: "Professional Grade",
  },
  {
    src: "https://readdy.ai/api/search-image?query=beautifully%20set%20dining%20table%20with%20elegant%20white%20porcelain%20dinnerware%2C%20candles%2C%20fresh%20flowers%2C%20luxury%20home%20entertaining%20photography&width=600&height=700&seq=show2&orientation=portrait",
    label: "Elegant Dining",
  },
  {
    src: "https://readdy.ai/api/search-image?query=premium%20kitchen%20knives%20and%20cutlery%20arranged%20on%20marble%20surface%2C%20damascus%20steel%20blades%2C%20professional%20photography%2C%20warm%20tones&width=600&height=700&seq=show3&orientation=portrait",
    label: "Premium Cutlery",
  },
  {
    src: "https://readdy.ai/api/search-image?query=organized%20modern%20kitchen%20pantry%20with%20glass%20storage%20containers%20and%20bamboo%20organizers%2C%20clean%20minimalist%20aesthetic%2C%20lifestyle%20photography&width=600&height=700&seq=show4&orientation=portrait",
    label: "Smart Storage",
  },
  {
    src: "https://readdy.ai/api/search-image?query=modern%20kitchen%20appliances%20espresso%20machine%20stand%20mixer%20on%20marble%20counter%2C%20premium%20home%20kitchen%2C%20warm%20ambient%20lighting&width=600&height=700&seq=show5&orientation=portrait",
    label: "Smart Appliances",
  },
  {
    src: "https://readdy.ai/api/search-image?query=ZEPHYRION%20kitchen%20brand%20lifestyle%20photo%2C%20family%20cooking%20together%20in%20beautiful%20modern%20kitchen%2C%20warm%20happy%20atmosphere%2C%20premium%20cookware&width=600&height=700&seq=show6&orientation=portrait",
    label: "Family Moments",
  },
];

export function CompanyShowcase() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-2">Why ZEPHYRION</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Crafted for Life
          </h2>
          <p className="text-stone-500 text-lg max-w-2xl mx-auto leading-relaxed">
            From our Phoenix, AZ headquarters, we curate the finest kitchen and dining essentials — designed to inspire creativity and elevate every meal.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-12">
          {showcaseImages.map((img, i) => (
            <div key={i} className="group relative overflow-hidden rounded-2xl" style={{ paddingBottom: '110%' }}>
              <img
                src={img.src}
                alt={img.label}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4">
                <span className="text-white font-semibold text-sm">{img.label}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: 'ri-award-line', title: 'Premium Quality', desc: 'Every product is rigorously tested to meet our exacting standards for durability, performance, and beauty.' },
            { icon: 'ri-leaf-line', title: 'Sustainably Sourced', desc: 'We partner with eco-conscious manufacturers who share our commitment to sustainable materials and practices.' },
            { icon: 'ri-truck-line', title: 'Free Shipping', desc: 'Enjoy free shipping on all orders over $150, with fast delivery to your door anywhere in the US.' },
          ].map(item => (
            <div key={item.title} className="flex gap-4 p-6 bg-stone-50 rounded-2xl">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
                <i className={`${item.icon} text-amber-600 text-xl`} />
              </div>
              <div>
                <h3 className="font-semibold text-stone-900 mb-1">{item.title}</h3>
                <p className="text-stone-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 border border-stone-300 hover:border-amber-500 text-stone-700 hover:text-amber-600 px-8 py-3.5 rounded-xl font-medium transition-all whitespace-nowrap"
          >
            Learn Our Story <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
